<template>
  <el-select
    filterable
    v-model="selectedValue"
    :disabled="disabled"
    :clearable="!required"
    :placeholder="required ? '必选' : '非必选'"
  >
    <el-option v-for="item in optionList" :label="item.label" :value="item.value" :key="item.value">
    </el-option>
  </el-select>
</template>

<script>
export default {
  name: 'filter-business-line',

  props: {
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    ops: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      optionList: [],
    }
  },

  computed: {
    selectedValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('update:value', val)
        this.$emit('change', val)
      },
    },
  },

  created() {
    if (this.ops) {
      this.optionList = [
        {
          label: '电单车',
          value: 2,
        },
        {
          label: '单车',
          value: 1,
        },
      ]
    } else {
      this.optionList = [
        {
          label: '电单车',
          value: 1203,
        },
        {
          label: '单车',
          value: 1204,
        },
      ]
    }
    if (this.required) {
      this.selectedValue = this.optionList[0].value
    }
  },
}
</script>
